import { isNull } from "option-t/nullable";

type NonNullables<TItems extends ReadonlyArray<unknown>> = {
  [key in keyof TItems]: NonNullable<TItems[key]>;
};
/**
 * Combines a list of nullable values, applies the given function on the
 * return the result.
 *
 * If any of the value is a null then the return value is a null.
 */
export const combineNullables = <
  const TItems extends ReadonlyArray<unknown>,
  TOutput,
>(
  operation: (...values: NonNullables<TItems>) => TOutput,
  ...values: TItems
): TOutput | null => {
  if (values.length === 0 || values.some(isNull)) {
    return null;
  } else {
    return operation(...(values as unknown as NonNullables<TItems>));
  }
};
